// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25WVL","left":"styles_left__1dA5w"};